import React from 'react';

const Expando = (props) => <div className="expando"> </div>;

export default Expando;
